import "reflect-metadata";
import {inject, injectable} from "inversify";
import {
    CompanyConfigurationRepository
} from "@dropDesk/domain/repositories/company_configurations/company_configurations.repository";
import {
    CompanyConfigurationEntity
} from "@dropDesk/domain/entities/company_configurations/company_configuration.entity";
import {
    NotificationsConfigurationEntity
} from "@dropDesk/domain/entities/company_configurations/notifications_configuration.entity";

@injectable()
export class SetConfigurationNotificationsUseCase {
    private _repository: CompanyConfigurationRepository;

    constructor(@inject(CompanyConfigurationRepository) repository: CompanyConfigurationRepository) {
        this._repository = repository;
    }

    public call(notifications: NotificationsConfigurationEntity): Promise<CompanyConfigurationEntity> {
        return this._repository.setConfigurationNotification(notifications);
    }
}
